import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SitePublicService} from 'src/app/services/site-public.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {Subscription} from 'rxjs';
import {PDFsDialogComponent} from '../../dialogs/pdfs-dialog/pdfs-dialog.component';
import {Clipboard} from '@angular/cdk/clipboard';

@Component({
  selector: 'app-pdfs',
  templateUrl: './pdfs.component.html',
  styleUrls: [ './pdfs.component.scss' ]
})
export class PdfsComponent implements OnInit, OnDestroy {

  private subscription: Subscription | undefined;

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'icon', 'key', 'file', 'copy', 'preview', 'delete' ];

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor (
    private _sitePublicService: SitePublicService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _spinnerService: SpinnerService,
    private _snackBar: SnackBarIconService,
    private _clipboard: Clipboard) {

    /*
    if (!this._authService.isAdmin) {
    this.router.navigate([ 'home' ]);
    }
    */

    this.loadData()
  }

  ngOnInit () {
  }

  ngOnDestroy () {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  loadData () {

    const waiting = this._spinnerService.show();

    // 1. Chama o serviço que retorna o Observable
    const statute$ = this._sitePublicService.loadPDFs();

    // 2. Se inscreve no Observable
    this.subscription = statute$.subscribe({
      next: (array: any[]) => {
        // Este código será executado na primeira vez E em cada mudança subsequente.
        this.dataSource = new MatTableDataSource(array);
        this.dataSource.sort = this.sort;
        // O 'waiting.close()' deve ser feito apenas na primeira vez.
        // Uma forma simples é verificar se o spinner está aberto ou usar 'finalize' no pipe.
        // apenas fechar, assumindo que já está aberto.
        if (waiting) {
          waiting.close();
        }
      },
      error: (error) => {
        console.error('Erro ao carregar dados: ', error);
        if (waiting) {
          waiting.close();
        }
        // Trate o erro (ex: exibir mensagem para o usuário)
      },
      // O complete não é chamado, pois é um Observable "infinito" (tempo real)
    });
  }


  openDialog (entity: any) {

    let data: any = {};
    if (entity) {
      data = entity;
    } else {
      data = {'id': "0", 'key': '', 'pdf_name': '', 'pdf_url': ''}
    }

    let dialogRef = this.dialog.open(PDFsDialogComponent, {
      width: '600px',
      height: '380px',
      panelClass: 'custom-dialog-container',
      data: data
    });


    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const waiting = this._spinnerService.show()

        const actionType: string = response[ 0 ];
        const form: any = response[ 1 ];
        const file: any = response[ 2 ];
        const formData = form.getRawValue();

        console.log("actionType: " + actionType);
        console.log("formData: " + JSON.stringify(formData));
        console.log("file: " + JSON.stringify(file.name));

        if (actionType == 'insert') {

          console.log("insert: " + JSON.stringify(formData));
          await this._sitePublicService.uploadPDF(file, formData.key, "pub_pdfs")
            .then(async () => {
              waiting.close();
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro ao adicionar pdf")
              this._snackBar.openSnackBar("Erro!", '', 'error')
            });
        }
      })

  }

  delete (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.key + "<br><br>Excluir este pdf?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._sitePublicService.deletePDF('pub_pdfs', element.key)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete link error: " + error.message)}
          )
      }
    })
  }

  copyToClipboard (element: any): void {

    const data = element;
    const sucesso = this._clipboard.copy(data);

    if (sucesso) {
      this._snackBar.openSnackBar("Copiado!", '', 'success')
    } else {
      console.error('Falha ao copiar a informação.');
    }
  }

}
